import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import SearchBox from "../../../components/SearchBox";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";
import { GeneralModalAdd } from "./GeneralModalAdd";

const GeneralList = () => {
  const [data, setData] = useState([]);

  const GeneralDataFunc = async () => {
    try {
      const userId = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/GeneralPd?UserId=${userId}&PageNumber=1&PageSize=100`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      console.log("response", response.data?.data);
      setData(response?.data?.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    GeneralDataFunc();
  }, []);

  const [deleteId, setDeleteId] = useState(null);

  const ResidedenceDeleteFunc = async () => {
    try {
      const response = await axios.delete(
        `${Api_Url}api/v1/GeneralPd/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      GeneralDataFunc();
    } catch (error) {
      return error.message;
    }
  };

  const columns = [
    {
      title: "Image",
      dataIndex: "selfieUrl",
      render: (selfieUrl) => (
        <a href={selfieUrl} target="_blank" rel="noopener noreferrer">
          <img
            alt="SelfieURL"
            src={selfieUrl}
            style={{
              width: 50,
              height: 50,
              borderRadius: 4,
              objectFit: "cover",
            }}
          />
        </a>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Application Number",
      dataIndex: "applicationNo",
    },
    {
      title: "Visit Type",
      dataIndex: "visitType",
    },
    {
      title: "Profile Type",
      dataIndex: "profileType",
    },
    {
      title: "Visit Type Description",
      dataIndex: "visitTypeDescription",
      render: (visitTypeDescription, record) => (
        <TextArea
          style={{ width: "200px", color: "black" }}
          rows={3}
          maxLength={50}
          disabled
          value={record.visitTypeDescription}
        />
      ),
    },
    {
      title: "PAN Number",
      dataIndex: "panNumber",
    },
    {
      title: "Residence Address",
      dataIndex: "residenceAddress",
      render: (residenceAddress, record) => (
        <TextArea
          style={{ width: "200px", color: "black" }}
          rows={3}
          maxLength={50}
          disabled
          value={record.residenceAddress}
        />
      ),
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (remarks, record) => (
        <TextArea
          style={{ width: "200px", color: "black" }}
          rows={3}
          maxLength={50}
          disabled
          value={record.remarks}
        />
      ),
    },
    {
      title: "Location",
      dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
      render: (text, record) => (
        <a
          href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-location-dot"></i>
        </a>
      ),
    },
    {
      title: "Last Activity",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}

          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">General PD</h3>
              <div>
                <button
                  className="btn btn-primary submit-btn mb-2"
                  onClick={handleOpenModal}
                >
                  Add General Pd
                </button>
                {isModalOpen && (
                  <GeneralModalAdd
                    onClose={handleCloseModal}
                    GeneralDataFetchFunc={GeneralDataFunc}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <ResidenceModalAdd ResidenceDataFetchFunc={ResidenceDataFunc} /> */}
      {/* <ResidenceDeleteModal
        Name="Delete Client"
        ResidenceDeleteFunction={ResidedenceDeleteFunc}
      /> */}
    </>
  );
};

export default GeneralList;
